import React, { useEffect, useState } from 'react';
import { db } from '../firebase';
import { collection, onSnapshot, doc, updateDoc } from 'firebase/firestore';
import { suspendDriver, unsuspendDriver } from '../services/adminService';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, CircularProgress, Chip } from '@mui/material';
import toast from 'react-hot-toast';

export const DriversPage = () => {
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, 'drivers'), (snapshot) => {
      const data = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setDrivers(data);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  const toggleKyc = async (driverId, currentStatus) => {
    if (!window.confirm(`${currentStatus ? 'Revoke KYC' : 'Approve KYC'} for this driver?`)) return;
    try {
      await updateDoc(doc(db, 'drivers', driverId), { kycVerified: !currentStatus });
      toast.success(`KYC ${!currentStatus ? 'approved' : 'revoked'}`);
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleSuspend = async (driverId) => {
    const reason = prompt('Reason for suspension:');
    if (!reason) return;
    try {
      await suspendDriver(driverId, reason);
      toast.success('Driver suspended');
    } catch (err) {
      toast.error(err.message);
    }
  };

  const handleUnsuspend = async (driverId) => {
    if (!window.confirm('Unsuspend this driver?')) return;
    try {
      await unsuspendDriver(driverId);
      toast.success('Driver unsuspended');
    } catch (err) {
      toast.error(err.message);
    }
  };

  if (loading) return <CircularProgress />;

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Driver ID</TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>KYC</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {drivers.map(driver => (
            <TableRow key={driver.id}>
              <TableCell>{driver.id.slice(-8)}</TableCell>
              <TableCell>{driver.businessName || driver.fullName || '-'}</TableCell>
              <TableCell>{driver.email}</TableCell>
              <TableCell><Chip label={driver.kycVerified ? 'Verified' : 'Pending'} color={driver.kycVerified ? 'success' : 'warning'} size="small" /></TableCell>
              <TableCell><Chip label={driver.suspended ? 'Suspended' : 'Active'} color={driver.suspended ? 'error' : 'success'} size="small" /></TableCell>
              <TableCell>
                <Button size="small" onClick={() => toggleKyc(driver.id, driver.kycVerified)}>{driver.kycVerified ? 'Revoke KYC' : 'Approve KYC'}</Button>
                {driver.suspended ? (
                  <Button size="small" color="primary" onClick={() => handleUnsuspend(driver.id)}>Unsuspend</Button>
                ) : (
                  <Button size="small" color="error" onClick={() => handleSuspend(driver.id)}>Suspend</Button>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
